"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var draft_group_filter_1 = __importDefault(require("../constants/actions/draft-group-filter"));

var draft_items_1 = __importDefault(require("../constants/actions/draft-items"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    grouped_options: [],
    options: [],
    selected: [],
    metas: [],
    focus_meta: null,
    filled_metas: []
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case draft_group_filter_1.default.INIT:
      {
        return Object.assign({}, state, {
          grouped_options: action.grouped_options,
          options: action.options,
          selected: action.selected,
          metas: action.metas,
          focus_meta: action.focus_meta,
          filled_metas: action.filled_metas
        });
      }

    case draft_items_1.default.CLEAR:
      {
        return Object.assign({}, state, {
          grouped_options: [],
          options: [],
          selected: [],
          metas: [],
          focus_meta: null,
          filled_metas: []
        });
      }

    case draft_group_filter_1.default.SELECT:
      return Object.assign({}, state, {
        selected: action.selected,
        filled_metas: action.filled_metas
      });

    case draft_group_filter_1.default.RESET:
      return Object.assign({}, state, {
        options: [],
        selected: [],
        focus_meta: null,
        filled_metas: []
      });

    case draft_group_filter_1.default.NAVIGATE:
      return Object.assign({}, state, {
        options: action.options,
        focus_meta: action.focus_meta
      });

    default:
      return state;
  }
}

exports.default = default_1;